window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.search-toggle').length) {
      import('./_search-toggle.js').then((module) => {
      module.Init();
    });
  }
});

export default {}
